export default {
  namespaced: true,
  state: {
    current: {},
    filter: {
      critique: true,
      viewing: true,
      showingDelete: false,
    },
    showingSlideshow: false,
  },
  getters: {
    showingDelete(state) {
      return state.filter.showingDelete;
    },
    filteredGallery(state, getters, rootState) {
      const gallery = rootState.study.gallery;

      const critique = gallery.filter(x => x.critique === true);
      const viewing = gallery.filter(x => x.critique === false);

      const filtered = [];

      if (state.filter.critique) filtered.push(critique);
      if (state.filter.viewing) filtered.push(viewing);
      return filtered.flat();
    },
    previousSubmission(state, getters) {
      const gallery = getters.filteredGallery;
      const current = gallery.findIndex(x => x.id === state.current.id);

      if (current === 0) {
        return gallery[gallery.length - 1];
      }

      return gallery[current - 1];
    },
    nextSubmission(state, getters) {
      const gallery = getters.filteredGallery;
      const current = gallery.findIndex(x => x.id === state.current.id);

      if (current + 1 === gallery.length) {
        return gallery[0];
      }
      return gallery[current + 1];
    },
  },
  actions: {
    setArtwork({ commit }, payload) {
      commit('SET_ARTWORK', payload);
    },
    closeSlideshow({ commit }) {
      commit('CLOSE_SLIDESHOW');
    },
    updateFilter({ commit }, payload) {
      switch (payload.filter) {
        case 'viewing':
          commit('SET_VIEWING', payload.value);
          break;
        case 'critique':
          commit('SET_CRITIQUE', payload.value);
          break;
        case 'showingDelete':
          commit('SET_DELETE', payload.value);
          break;
      }
    },
  },
  mutations: {
    SET_ARTWORK(state, payload) {
      state.current = payload;
      if (!state.showingSlideshow) state.showingSlideshow = true;
    },
    CLOSE_SLIDESHOW(state) {
      state.showingSlideshow = false;
    },
    SET_CRITIQUE(state, payload) {
      state.filter.critique = payload;
    },
    SET_VIEWING(state, payload) {
      state.filter.viewing = payload;
    },
    SET_DELETE(state, payload) {
      state.filter.showingDelete = payload;
    },
  },
};
